module.exports = __webpack_public_path__ + "static/img/qrcode.13c9cf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/qrcode.png
// module id = aODI
// module chunks = 34